import React, { useContext, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import axios from 'axios'
import Sidebar from 'components/sidebar'
import Topbar from 'components/topbar'
import Toast from 'components/toast/Toast'
import { UserContext, UserTypes } from 'context/UserContext'

interface BaseLayoutProps {
  children?: React.ReactNode
  title?: string
  isBackNav?: boolean
}

const BaseLayout = ({ children, title, isBackNav }: BaseLayoutProps) => {
  const [, dispatch] = useContext(UserContext)
  const [sidebarVisibility, setSidebarVisibility] = useState(false)
  const { toastContainer } = Toast()
  const location = useLocation()

  axios.interceptors.request.use(
    function (config) {
      const user = localStorage.getItem('user')
      const token = user ? JSON.parse(user).token : null
      config.headers.Authorization = token ? 'Bearer ' + token : null
      return config
    },
    function (error) {
      return Promise.reject(error)
    },
  )

  axios.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      if (error.response.status === 401) {
        localStorage.removeItem('user')
        dispatch({ type: UserTypes.SIGN_OUT })
      }
      return Promise.reject(error)
    },
  )

  let updatedTitle = title
  if (location.state && location.state.storeName) updatedTitle = location.state.storeName

  return (
    <div data-testid="base-layout" className="home">
      <Sidebar closeSidebar={() => setSidebarVisibility(false)} visibility={sidebarVisibility} />
      <div className="bg-gray-100 home__container">
        <Topbar
          title={updatedTitle}
          toggleSidebar={() => setSidebarVisibility(!sidebarVisibility)}
          isBackNav={isBackNav}
        />
        <div
          id="toast"
          data-testid="toast"
          className="w-[calc(100%-370px)] left-[328px] z-10 mt-6 fixed"
        />
        {toastContainer}
        {children ?? <Outlet />}
      </div>
    </div>
  )
}

export default BaseLayout
